/**
 * The search of the dropdowns and lists: case and accents ignored, and every
 * word typed must appear, in any order (« cas ma » finds « Casablanca Maarif »).
 */

/** Lower case, without accents: « Écran » and « ecran » are the same search. */
export const flat = (s: string): string => s.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()

/** Whether a text matches every word of a query. */
export function matches(text: string, query: string): boolean {
  const words = flat(query).split(/\s+/).filter(Boolean)
  if (!words.length) return true
  const t = flat(text)
  return words.every((w) => t.includes(w))
}

/** The options matching every word typed. */
export function filterOptions<T extends { label: string }>(options: T[], query: string): T[] {
  const words = flat(query).split(/\s+/).filter(Boolean)
  if (!words.length) return options
  return options.filter((o) => { const l = flat(o.label); return words.every((w) => l.includes(w)) })
}

/**
 * The rows of a table fully loaded that match a query and the screen's other
 * filters: `text` gives each row's searchable values (null ones skipped),
 * `keep` the other filters. A small table filters in the browser; a large one
 * asks its API.
 */
export function filterRows<T>(rows: readonly T[], query: string, text: (r: T) => ReadonlyArray<string | number | null | undefined>,
                              keep: (r: T) => boolean = () => true): T[] {
  return rows.filter((r) => keep(r) && matches(text(r).filter((v) => v !== null && v !== undefined).join(' '), query))
}
